<template>
  <Modal
    v-model="state"
    :title="plustitle"
    width="900"
    class-name="c-label vertical-center-modal"
    :mask-closable="false"
    @on-visible-change="bindGetData"
  >
    <div class="m-form">
      <Form :label-width="140">
        <FormItem label="创意标签组名称">
          <p-input ref="Input" v-model.trim="landData.title" placeholder="请输入标题" :max="20" />
        </FormItem>
        <FormItem label="创意标签">
          <p class="g-error-text" v-if="!edit">注: 最多20个标签，每个标签最多10个字，标签之间用换行分隔开</p>
          <Input
            v-model.trim="labelContent"
            type="textarea"
            style="width: 240px"
            :autosize="{ minRows: 15, maxRows: 15 }"
            placeholder="最多20个标签，每个标签最多10个字，标签之间用换行分隔开"
          />
          <div class="center-btn">
            <Button @click="addRight">添加 ></Button>
          </div>
          <div class="right-labels">
            <div class="tag" v-for="(val, index) in landData.labels" :key="val + index">
              <span>{{ val }}</span>
              <span @click="handleCloseTag(index)"><Icon type="md-close" size="12" /></span>
            </div>
          </div>
          <div class="tooltip">
            <div>
              已输入<span class="g-error-text">{{ rows }}</span
              >个标签
            </div>
            <div>
              已添加<span class="g-error-text">{{ labels }}</span
              >个标签
            </div>
          </div>
        </FormItem>
      </Form>
    </div>

    <template slot="footer">
      <div class="m-foot">
        <Button @click="$emit('input', false)">取消</Button>
        <Button type="primary" :loading="loading" @click="save">
          <span v-if="loading">提交中...</span>
          <span v-else>确认</span>
        </Button>
      </div>
    </template>
  </Modal>
</template>
<script>
import { trim, isArray, isEmpty } from '@/common/js/utils'
import PInput from '@/components/input/input-len'
export default {
  name: 'labelSet',
  components: { PInput },
  props: {
    value: {
      type: Boolean
    },
    title: {
      type: String
    },
    loading: {
      type: Boolean,
      default() {
        return false
      }
    },
    info: {
      type: Object,
      default() {
        return {
          title: '',
          labels: []
        }
      }
    },
    edit: {
      type: Boolean,
      default() {
        return false
      }
    }
  },
  computed: {
    state: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    plustitle() {
      return `${this.edit ? '修改' : '新增'}${this.title}`
    },
    rows() {
      return this.labelContent ? this.labelContent.split(/\r?\n/).filter((ret) => trim(ret)).length : 0
    },
    labels() {
      return isArray(this.landData.labels) ? this.landData.labels.length : 0
    }
  },
  watch: {
    info: {
      handler(nVal) {
        this.updateInfo()
      },
      deep: true
    }
  },
  methods: {
    bindGetData(e) {
      if (e) return
      this.labelContent = ''
      this.landData = {
        id: '',
        title: '',
        labels: []
      }
    },
    addRight() {
      const relLables = this.landData.labels || []
      const labels = this.labelContent.split(/\r?\n/).filter((ret) => trim(ret))
      const union = this.mergeArray(relLables, labels)
      if (union.length > 20) {
        this.$Message.error('最多20个标签，请删除部分标签再试！')
      } else {
        this.$set(this.landData, 'labels', union)
      }
    },
    mergeArray(list, add) {
      if (!isArray(add)) return list
      const result = []
      list.forEach((ret) => {
        result.push(ret)
      })
      add.forEach((ret) => {
        const index = result.findIndex((meta) => meta === ret)
        if (index < 0) result.push(ret)
      })
      return result
    },
    updateInfo() {
      const info = JSON.parse(JSON.stringify(this.info))
      this.landData = info
    },
    handleCloseTag(index) {
      this.landData.labels.splice(index, 1)
    },
    // 提交验证
    save() {
      const labels = this.landData.labels
      if (!isArray(labels) || labels.length < 1) {
        this.$Message.error('至少有一个标签！')
        return
      }
      const indexList = []
      labels.forEach((ret, index) => {
        ret.length > 10 && indexList.push(index + 1)
      })
      if (indexList.length > 0) {
        const msg = `第${indexList.join('，')}个标签长度超过限制，每个标签最多10个字！`
        this.$Message.error(msg)
        return
      }
      if (isEmpty(this.landData.title)) {
        this.$Message.error('创意标签组标题不可为空！')
        return
      }
      if (this.$refs.Input.len > 20) {
        this.$Message.error('创意标签组标题最多20个字符！')
        return
      }
      this.$emit('on-save', this.landData)
    }
  },
  data() {
    return {
      labelContent: '',
      landData: {
        title: '',
        labels: []
      }
    }
  },
  created() {},
  mounted() {
    this.$nextTick(() => {
      this.updateInfo()
    })
  }
}
</script>
<style lang="scss" scoped>

.c-label {
  position: relative;

  .m-form {
    overflow-y: auto;
scrollbar-width: thin;
-webkit-overflow-scrolling: touch;

    max-height: 480px;

    .center-btn {
      display: inline-block;
      margin: 0 20px;
    }

    .right-labels {
      overflow-y: auto;
      display: inline-block;
      width: 240px;
      height: 265px;
      position: relative;
      vertical-align: middle;
      line-height: normal;
      border: solid #DCDEE2 1px;
      border-radius: 4px;
      padding: 4px 7px;

      .tag {
        display: flex;
        justify-content: space-between;
        height: 32px;
        margin: 1px 12px 8px 0;
        line-height: 30px;
        width: 220px;
        text-overflow: ellipsis;
        border: solid #D9D9D9 1px;
        border-radius: 4px;
        padding: 0 7px;
        background-color: #F7F7F7;

        span:nth-child(1) {
          width: 206px;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        span:nth-child(2) {
          color: #898989;
        }

        span:nth-child(2):hover {
          color: #464646;
          cursor: pointer;
        }
      }

      .tag:hover {
        color: #8C929E;
        cursor: pointer;
      }
    }

    .right-labels:hover {
      border: solid #57A3F3 1px;
    }

    .tooltip {
      display: flex;
      justify-content: space-between;
      width: 425px;
    }
  }

}
</style>
